import { IPostGeneralStocksResult } from '@/fsd/entities/remains/model/types/IPostGeneralStocksResult';
import BodyTable from '@/fsd/shared/ui/BodyTable';
import Table from '@/fsd/shared/ui/Table';
import styles from '../Remains/Remains.module.scss';
import RemainsTableBody from './RemainsTableBody';
import RemainsTableHeader from './RemainsTableHeader';

interface IProps {
  data: IPostGeneralStocksResult;
}

const RemainsTable = ({ data }: IProps) => {
  return (
    <div className={styles.banksTableScroll}>
      <Table tableClassName={styles.tableBanks}>
        <RemainsTableHeader />
        <BodyTable bodyClassName={styles.bodyTableBanks}>
          <RemainsTableBody data={data} />
        </BodyTable>
      </Table>
    </div>
  );
};

export default RemainsTable;
